// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetransportserviceforcompany() {



const cardData = {


    keyword: "Pune Transport Service for Company",

    headingDescription: "SSK Logistic provides organized transport service for companies in Pune that need dependable movement of business goods, corporate cargo, industrial materials, commercial inventory, machinery, freight, and regular company consignments. Businesses often require transportation between offices, factories, warehouses, suppliers, distributors, and customer locations, making proper vehicle selection, pickup coordination, route planning, and delivery scheduling important parts of daily operations. SSK Logistic supports companies with practical road transportation arrangements for local Pune movement as well as regional and interstate business routes, helping organizations coordinate their cargo transportation according to shipment size, cargo type, vehicle capacity, and destination requirements.",

    topPlaces: [
        {
            title: "Magarpatta",
            description: "Magarpatta is an important corporate and commercial destination in Pune where businesses may require movement of office supplies, equipment, documents, inventory, and commercial goods. SSK Logistic supports company transportation requirements with suitable vehicle coordination for business-related deliveries and cargo movement."
        },
        {
            title: "Pune to Indore",
            description: "Pune to Indore connects two major commercial and industrial markets and is useful for companies moving inventory, equipment, machinery, packaged products, and business cargo. SSK Logistic coordinates interstate road transportation according to shipment size, vehicle capacity, and delivery requirements."
        },
        {
            title: "Kharadi",
            description: "Kharadi has a strong concentration of corporate offices, commercial establishments, technology businesses, and supporting operations. SSK Logistic assists companies with transportation of office equipment, commercial materials, inventory, supplies, and business consignments between Kharadi and other operational locations."
        },
        {
            title: "Pune to Ahmedabad",
            description: "The Pune to Ahmedabad corridor supports regular movement of commercial and industrial goods between two important business centers. SSK Logistic coordinates company cargo transportation for machinery, inventory, production materials, finished products, and larger business consignments requiring interstate road movement."
        },
        {
            title: "Hadapsar",
            description: "Hadapsar combines commercial, industrial, warehousing, and corporate activity, creating varied transportation requirements for businesses. SSK Logistic supports company cargo movement from this area for equipment, supplies, packaged goods, industrial materials, and regular commercial shipments."
        },
        {
            title: "Pune to Bengaluru",
            description: "Pune to Bengaluru is a significant business and industrial route connecting companies across Maharashtra and Karnataka. SSK Logistic helps businesses transport machinery, components, commercial inventory, equipment, and corporate consignments with planned long-distance road transportation."
        },
        {
            title: "Baner",
            description: "Baner is a prominent corporate and commercial area where businesses regularly require movement of office materials, equipment, promotional stock, supplies, and commercial goods. SSK Logistic coordinates suitable transportation for companies based on cargo quantity, pickup requirements, and destination."
        },
        {
            title: "Pune to Nagpur",
            description: "Pune to Nagpur provides an important road connection for companies distributing products and industrial materials toward central Maharashtra. SSK Logistic supports business freight transportation for machinery, packaged inventory, commercial goods, equipment, and larger company consignments."
        },
        {
            title: "Wagholi",
            description: "Wagholi has growing commercial, warehousing, residential-support, and business activity with transportation requirements for various types of company cargo. SSK Logistic coordinates movement of inventory, supplies, equipment, and commercial goods between Wagholi and business destinations."
        },
        {
            title: "Pune to Hyderabad",
            description: "Pune to Hyderabad is a major interstate business corridor supporting movement of industrial and commercial cargo between western and southern India. SSK Logistic provides transportation coordination for companies moving equipment, machinery, inventory, components, and business freight over longer road distances."
        }
    ],

    "services": [
        {
            "name": "transport service for companies pune",
            "description": "SSK Logistic provides transport service for companies pune for businesses requiring organized movement of goods, equipment, supplies, inventory, and commercial cargo. Transportation can be coordinated according to company requirements, shipment volume, vehicle capacity, pickup location, route, and destination."
        },
        {
            "name": "corporate transport services pune",
            "description": "Corporate transport services pune support businesses that need dependable movement of commercial goods, office equipment, supplies, inventory, and business consignments. SSK Logistic coordinates suitable road transportation around the operational requirements of corporate customers."
        },
        {
            "name": "company goods transport pune",
            "description": "Company goods transport pune is useful for businesses moving products, raw materials, machinery, packaging supplies, inventory, and other commercial goods. SSK Logistic coordinates vehicle and route requirements according to cargo type, quantity, loading conditions, and destination."
        },
        {
            "name": "business transport services pune",
            "description": "Business transport services pune from SSK Logistic support companies moving cargo between offices, factories, warehouses, suppliers, distributors, and customers. Transportation arrangements can be planned for both recurring business movements and individual commercial shipments."
        },
        {
            "name": "corporate goods transportation pune",
            "description": "Corporate goods transportation pune covers movement of company inventory, equipment, products, supplies, machinery, and commercial cargo. SSK Logistic coordinates road vehicles based on shipment characteristics, vehicle capacity, route distance, pickup requirements, and delivery expectations."
        },
        {
            "name": "company logistics services pune",
            "description": "SSK Logistic supports company logistics services pune by coordinating transportation for businesses that regularly move goods between operational locations. Services can cover factory dispatches, warehouse transfers, supplier deliveries, commercial inventory movement, and interstate cargo transportation."
        },
        {
            "name": "corporate logistics company pune",
            "description": "Businesses searching for a corporate logistics company pune can coordinate transportation requirements with SSK Logistic for commercial and industrial cargo. Vehicle planning, route coordination, pickup arrangements, and destination delivery can be organized around individual company requirements."
        },
        {
            "name": "industrial company transport pune",
            "description": "Industrial company transport pune supports manufacturers, engineering businesses, factories, and production units moving machinery, components, raw materials, equipment, and finished products. SSK Logistic coordinates suitable road transportation based on cargo dimensions, weight, route, and vehicle capacity."
        },
        {
            "name": "commercial transport services pune",
            "description": "Commercial transport services pune are suitable for businesses moving inventory, packaged products, equipment, supplies, and trading goods between commercial locations. SSK Logistic provides transportation coordination according to shipment size, vehicle requirements, destination, and delivery schedule."
        },
        {
            "name": "business cargo transportation pune",
            "description": "Business cargo transportation pune helps companies move commercial and industrial consignments between factories, warehouses, offices, suppliers, and customers. SSK Logistic coordinates suitable vehicles and road routes according to cargo type, quantity, dimensions, and destination."
        },
        {
            "name": "company freight services pune",
            "description": "Company freight services pune from SSK Logistic support businesses transporting larger consignments between manufacturing units, warehouses, suppliers, and commercial markets. Freight transportation can be planned according to cargo volume, vehicle capacity, route distance, and delivery requirements."
        },
        {
            "name": "corporate freight transportation pune",
            "description": "Corporate freight transportation pune provides companies with coordinated road movement for larger commercial shipments, industrial materials, machinery, inventory, and business cargo. SSK Logistic plans transportation according to the specific characteristics and destination of each consignment."
        },
        {
            "name": "company truck transport pune",
            "description": "Company truck transport pune is suitable for businesses requiring dedicated road vehicles for commercial or industrial shipments. SSK Logistic coordinates truck transportation according to cargo quantity, loading requirements, route distance, vehicle capacity, and delivery location."
        },
        {
            "name": "corporate truck transportation pune",
            "description": "Corporate truck transportation pune supports businesses that require truck-based movement of inventory, equipment, commercial goods, machinery, and industrial materials. SSK Logistic coordinates suitable vehicle arrangements for local, regional, and interstate company transportation requirements."
        },
        {
            "name": "company cargo transport pune",
            "description": "Company cargo transport pune supports businesses moving regular or one-time consignments between operational locations. SSK Logistic coordinates cargo transportation for packaged goods, equipment, machinery, inventory, supplies, and industrial materials according to shipment requirements."
        },
        {
            "name": "business logistics solutions pune",
            "description": "Business logistics solutions pune from SSK Logistic help companies coordinate transportation requirements across suppliers, warehouses, factories, offices, and customers. Road cargo movement can be organized around shipment type, route, vehicle capacity, pickup arrangements, and delivery schedules."
        },
        {
            "name": "corporate transportation provider pune",
            "description": "A corporate transportation provider pune can help businesses manage recurring movement of commercial and industrial goods. SSK Logistic coordinates vehicle allocation, route planning, cargo transportation, pickup requirements, and delivery arrangements for companies operating across different locations."
        },
        {
            "name": "company transport service provider pune",
            "description": "SSK Logistic supports businesses looking for a company transport service provider pune for organized movement of cargo, inventory, machinery, equipment, and supplies. Transportation arrangements are coordinated around the company's shipment volume, destination, vehicle requirements, and operational schedule."
        },
        {
            "name": "reliable corporate transport pune",
            "description": "Reliable corporate transport pune requires consistent coordination of vehicles, cargo details, pickup locations, routes, and delivery destinations. SSK Logistic supports corporate businesses with transportation arrangements for commercial inventory, industrial materials, equipment, and regular business shipments."
        },
        {
            "name": "professional company transport pune",
            "description": "Professional company transport pune involves organized planning from cargo pickup and loading through road movement and final delivery. SSK Logistic coordinates business transportation requirements with attention to shipment characteristics, vehicle suitability, route distance, and destination conditions."
        },
        {
            "name": "industrial transportation company pune",
            "description": "Industrial transportation company pune requirements can involve machinery, production materials, components, equipment, and finished industrial goods. SSK Logistic supports manufacturers and industrial companies with suitable road transportation based on cargo weight, dimensions, vehicle capacity, and route requirements."
        },
        {
            "name": "corporate goods transport service",
            "description": "Corporate goods transport service from SSK Logistic supports companies moving commercial inventory, office equipment, business supplies, machinery, and other goods between operational locations. Transportation can be coordinated according to shipment size, route, vehicle capacity, and delivery requirements."
        },
        {
            "name": "company logistics partner pune",
            "description": "Businesses requiring a company logistics partner pune can coordinate recurring and one-time transportation requirements with SSK Logistic. Support can include factory dispatches, warehouse transfers, supplier movements, commercial deliveries, and interstate business cargo transportation."
        },
        {
            "name": "business transportation solutions pune",
            "description": "Business transportation solutions pune from SSK Logistic are designed around the practical cargo requirements of companies across different industries. Vehicle selection, route planning, pickup coordination, and delivery arrangements can be adapted to the shipment type, volume, destination, and schedule."
        },
        {
            "name": "corporate logistics services pune",
            "description": "Corporate logistics services pune support businesses with transportation requirements involving commercial goods, industrial materials, equipment, inventory, and freight. SSK Logistic coordinates road movement between corporate facilities, factories, warehouses, suppliers, and customer destinations."
        }
    ],

    "tableData": [
        ["transport service for companies pune", "corporate transport services pune"],
        ["company goods transport pune", "business transport services pune"],
        ["corporate goods transportation pune", "company logistics services pune"],
        ["corporate logistics company pune", "industrial company transport pune"],
        ["commercial transport services pune", "business cargo transportation pune"],
        ["company freight services pune", "corporate freight transportation pune"],
        ["company truck transport pune", "corporate truck transportation pune"],
        ["company cargo transport pune", "business logistics solutions pune"],
        ["corporate transportation provider pune", "company transport service provider pune"],
        ["reliable corporate transport pune", "professional company transport pune"],
        ["industrial transportation company pune", "corporate goods transport service"],
        ["company logistics partner pune", "business transportation solutions pune"],
        ["corporate logistics services pune", "Pune Transport Service for Company"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Transportation Designed for Business Operations",
            WhyChoosedescription: "Companies often have different transportation requirements for factories, warehouses, offices, suppliers, and customers. SSK Logistic coordinates road cargo movement according to the operational needs of each business, including shipment size, cargo type, route, and destination."
        },
        {
            WhyChooseheading: "Support for Corporate Cargo",
            WhyChoosedescription: "Corporate shipments can include office equipment, commercial inventory, machinery, supplies, packaged products, and industrial materials. SSK Logistic helps businesses coordinate suitable transportation arrangements for these different categories of company cargo."
        },
        {
            WhyChooseheading: "Local Pune Connectivity",
            WhyChoosedescription: "Business locations across Pune may require regular transportation between commercial areas, industrial zones, warehouses, and distribution points. SSK Logistic supports local company transportation requirements with vehicle coordination based on cargo volume and delivery needs."
        },
        {
            WhyChooseheading: "Interstate Business Routes",
            WhyChoosedescription: "Companies frequently distribute goods beyond Pune to other commercial and industrial markets. SSK Logistic supports interstate transportation toward destinations across Maharashtra and other states, coordinating suitable vehicles and road routes for longer-distance business cargo."
        },
        {
            WhyChooseheading: "Flexible Vehicle Coordination",
            WhyChoosedescription: "Different company shipments may require different vehicle capacities. SSK Logistic considers cargo quantity, dimensions, weight, loading requirements, and route distance while coordinating transportation options for commercial goods, industrial materials, machinery, and freight."
        },
        {
            WhyChooseheading: "Factory and Warehouse Movement",
            WhyChoosedescription: "Manufacturers and distributors often need transportation between production units, warehouses, suppliers, and customer locations. SSK Logistic supports these movements with organized pickup, vehicle allocation, route planning, and delivery coordination."
        },
        {
            WhyChooseheading: "Recurring Business Transportation",
            WhyChoosedescription: "Businesses with regular dispatch schedules can require consistent transportation coordination for inventory and commercial goods. SSK Logistic supports recurring company transportation requirements as well as individual shipments based on the specific cargo and route involved."
        },
        {
            WhyChooseheading: "Practical Logistics Coordination",
            WhyChoosedescription: "Effective company transportation involves more than arranging a vehicle. SSK Logistic coordinates important details such as pickup location, cargo information, vehicle capacity, loading requirements, route distance, destination, and delivery expectations to support smoother business logistics."
        }
    ]

};















const faqData = [
    {
        question: "What company transportation services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic helps companies manage the movement of commercial goods, industrial materials, equipment, machinery, stock, and other business consignments from Pune to different destinations according to their transportation requirements."
    },
    {
        question: "Can SSK Logistic arrange transportation for companies from Pune to other cities?",
        answer: "Companies can coordinate goods movement from Pune to locations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other destinations across India."
    },
    {
        question: "What business goods can companies transport through SSK Logistic?",
        answer: "Suitable company consignments may include raw materials, finished products, machinery, equipment, commercial inventory, packaged goods, industrial supplies, warehouse stock, and other goods requiring organized transportation."
    },
    {
        question: "Can SSK Logistic support companies with regular transportation needs?",
        answer: "Businesses requiring frequent goods movement can discuss recurring transportation arrangements based on their regular routes, shipment volume, pickup frequency, vehicle requirements, and expected delivery schedules."
    },
    {
        question: "How does SSK Logistic select a transport vehicle for company goods?",
        answer: "Vehicle planning is based on practical shipment information such as cargo weight, dimensions, quantity, volume, loading requirements, material type, route distance, and delivery destination."
    },
    {
        question: "Can companies arrange Pune to Mumbai transportation through SSK Logistic?",
        answer: "Yes, companies can arrange transportation between Pune and Mumbai for commercial stock, industrial materials, equipment, machinery, supplies, packaged goods, and other suitable business consignments."
    },
    {
        question: "Does SSK Logistic provide company transportation outside Maharashtra?",
        answer: "Interstate company goods transportation can be coordinated from Pune toward Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other parts of India according to the shipment and route requirements."
    },
    {
        question: "Is SSK Logistic suitable for manufacturing companies in Pune?",
        answer: "Manufacturing businesses can use transportation support for moving raw materials, finished products, machinery, equipment, production supplies, and commercial inventory between factories, warehouses, suppliers, and customer locations."
    },
    {
        question: "Can SSK Logistic customize transportation for a company's requirements?",
        answer: "Transportation arrangements can be structured around the company's pickup location, destination, cargo type, quantity, loading conditions, vehicle capacity, delivery timeline, and frequency of goods movement."
    },
    {
        question: "What information should a company provide for a transport enquiry?",
        answer: "Companies can share the pickup location, delivery destination, type of goods, approximate weight or quantity, dimensions when applicable, loading details, preferred vehicle, and required delivery timeframe to discuss the transportation requirement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay Bhosale",
        feedback: "Our company needed regular transportation for commercial materials from Pune to Mumbai. SSK Logistic understood our shipment pattern and coordinated the vehicle requirements according to our business schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Reema Deshpande",
        feedback: "We approached SSK Logistic to move finished goods from Pune to Indore. The team collected the relevant cargo information and arranged the transportation in a clear and organized manner.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Transport Service for Company",
  "image": "https://ssklogistics.in/assets/images/pune-transport-service-for-company.webp",
  "description": "SSK Logistics provides Pune Transport Service for Company requirements, helping businesses coordinate the movement of goods, commercial materials, cargo and regular consignments across Pune, Maharashtra and interstate destinations. Transport service for companies Pune can support manufacturers, distributors, wholesalers, retailers, warehouses and corporate businesses that need organized transportation for recurring or project-based shipments. Corporate transport services Pune are planned around cargo type, vehicle requirements, route distance, dispatch schedules and destination needs, while company goods transport Pune can cover commercial products, industrial materials, packaged goods, equipment and other business consignments. Business transport services Pune may include local distribution, warehouse transfers, supplier movements, branch deliveries and interstate transportation. For corporate goods transportation Pune, SSK Logistics assists with practical vehicle coordination and shipment movement suited to commercial requirements. Company logistics services Pune can also support businesses that need transportation coordination as part of their wider supply chain, including warehouse-to-business and business-to-customer cargo movement. Corporate logistics requirements can involve regular freight transportation, cargo coordination, route planning and delivery scheduling for multiple business destinations. SSK Logistics focuses on flexible commercial transportation solutions that help companies manage their goods movement with responsive coordination and suitable vehicle arrangements.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/pune-transport-service-for-company"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Pune Transport Service for Company | Corporate Goods & Logistics Transportation | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides company and corporate transport services in Pune for business goods, commercial cargo, freight and logistics requirements with flexible transportation coordination."
  />

  <meta
    name="keywords"
    content="Pune Transport Service for Company, transport service for companies Pune, corporate transport services Pune, company goods transport Pune, business transport services Pune, corporate goods transportation Pune, company logistics services Pune, corporate logistics Pune, corporate logistics services Pune, company transport services Pune, business goods transportation Pune, corporate transportation Pune, company goods transportation Pune, corporate freight transportation Pune, corporate cargo transportation Pune, business logistics services Pune, company freight services Pune, company cargo transport Pune, commercial transport services Pune, commercial goods transport Pune, corporate goods transport Pune, business cargo transportation Pune, business freight transport Pune, corporate supply chain transport Pune, warehouse transport for companies Pune, industrial company transport Pune, B2B transport services Pune, corporate shipment transportation Pune, business logistics company Pune, company transportation services Pune, corporate transportation services Maharashtra, interstate company goods transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetransportserviceforcompany;